/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetIrsInfoRequest} from '@cash-web/protos/squareup/cash/janus/api/GetIrsInfoProto.pb'
import {GetIrsInfoResponse} from '@cash-web/protos/squareup/cash/janus/api/GetIrsInfoProto.pb'


export const getIrsInfo = (request: GetIrsInfoRequest, options?: CashRequestOptions) => post<GetIrsInfoRequest, GetIrsInfoResponse>("/2.0/cash/get-irs-info", request, {...options, rejectOnError: true })